import React from 'react'
import BedbankSearchTileWalledContent from './BedbankSearchTileWalledContent'
import BedbankMetaSearchTileSignUpButton from './BedbankMetaSearchTileSignUpButton'
import { EmptyObject } from 'lib/object/objectUtils'
import SearchTileActionButton from '../shared/SearchTileActionButton'

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary
  filters?: App.OfferListFilters
  utmBp?: string
  kind?: 'primary' | 'secondary' | 'tertiary'
}

function BedbankMetaSearchTileAction({
  offer,
  filters = EmptyObject,
  utmBp,
  kind = 'primary',
}: Props) {
  // Only on bedbank titles when bp=2 is set and the user isn’t logged in. Clicking on “Login for member savings” triggers the login modal.
  const isLoginForMemberSavings = utmBp === '2'

  return <BedbankSearchTileWalledContent
    wall={<BedbankMetaSearchTileSignUpButton isLoginForMemberSavings={isLoginForMemberSavings} kind={kind} />}
    offer={offer}
    filters={filters}
    hidePricing={isLoginForMemberSavings || offer.hidePricing}
  >
    <SearchTileActionButton kind={kind} />
  </BedbankSearchTileWalledContent>
}

export default BedbankMetaSearchTileAction
